// In Text.tsx
import {createText} from '@shopify/restyle';
import {Theme} from './../index';

const ThemedText = createText<Theme>();

export default ThemedText;